import type { IconSvgObject } from './types';

const FlagTriangleLeftIcon: IconSvgObject = [
  ["path", { d: "M18.25 9V17.4118V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.25927 5.43925L13.9953 3.12627C15.9058 2.19322 16.861 1.72669 17.5555 2.16767C18.25 2.60865 18.25 3.68174 18.25 5.82793V15.5484L9.18611 10.8056C6.88701 9.60252 5.73746 9.001 5.7501 8.07394C5.76274 7.14688 6.92825 6.57767 9.25927 5.43925Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default FlagTriangleLeftIcon;
